import { jsx, Fragment } from "react/jsx-runtime";
import { animated, useTransition, config } from "react-spring";
const AnimatedDiv = animated.div;
const SlideInOutRight = ({ children, show }) => {
  const slideInOutRight = useTransition(show, {
    config: config.stiff,
    from: {
      position: "absolute",
      opacity: 0,
      transform: "translate3d(0px, 0px, 0px)",
      right: "0",
      bottom: "8px"
    },
    enter: {
      position: "absolute",
      opacity: 1,
      transform: "translate3d(-10px, 0px, 0px)",
      right: "0"
    },
    leave: {
      position: "absolute",
      opacity: 0,
      transform: "translate3d(0px, 0px, 0px)"
    }
  });
  return /* @__PURE__ */ jsx(Fragment, { children: slideInOutRight(
    (style, item) => item && /* @__PURE__ */ jsx(AnimatedDiv, { style, children })
  ) });
};
export {
  SlideInOutRight
};
